import { ConfirmModalEvent, DismissModalEvent, OpenModalEvent, ShowModalOptions } from '@ui-common/components/Modal'
import { GlobalServicesContext } from '@ui-common/state/GlobalServiceProvider'
import { use, useCallback } from 'react'

export interface GlobalServices {
  openModal: (options: ShowModalOptions) => void
  closeModal: () => void
  confirmModal: () => void
}

export const useGlobalServices = (): GlobalServices => {
  const { modalService } = use(GlobalServicesContext)
  const modalSend = useCallback(
    (event: OpenModalEvent | ConfirmModalEvent | DismissModalEvent) => modalService.send(event),
    [modalService],
  )

  return {
    openModal: useCallback((options: ShowModalOptions) => modalSend({ type: 'OPEN', data: options }), [modalSend]),
    closeModal: useCallback(() => modalSend({ type: 'DISMISS' }), [modalSend]),
    confirmModal: useCallback(() => modalSend({ type: 'CONFIRM' }), [modalSend]),
  }
}
